export default __webpack_public_path__ + "static/media/scroll2.5acdd41f.jpg";